import { uniqueId } from "lodash";
import { useState } from "react";

export const useId = (prefix?: string) => {
    let [id] = useState(uniqueId(prefix));
    return id;
};
